export default __webpack_public_path__ + "static/media/phone-call.ec433426.png";